import { Alert, Flex } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import Tree from '@/components/shared/Tree';
import Loader from '@/components/ui/Loader';
import { useSidebarDocumentsStore } from '@/stores/local/sidebar/SidebarDocumentsStore';

import { renderNode } from './renderNode';

import s from './TreeSelect.module.scss';

const TreeSelect: React.FC = () => {
  const { treeStore, searchDocumentStore, selectionStore } = useSidebarDocumentsStore();

  React.useEffect(() => {
    selectionStore.setSelectAll(false);
  }, [selectionStore]);

  if (treeStore.meta.isLoading || treeStore.openMeta.isLoading || searchDocumentStore.meta.isLoading) {
    return <Loader gap={0} fullHeight type="dots" size="xl" text="Ищу документы..." />;
  }

  if (treeStore.meta.isError) {
    return (
      <Alert ml="lg" mr="lg" color="red">
        Не удалось загрузить документы
      </Alert>
    );
  }

  if (treeStore.children.length === 0) {
    return (
      <Alert ml="lg" mr="lg">
        Документы не загружены
      </Alert>
    );
  }

  return (
    <Flex className={s.root} direction="column" align="flex-start" gap="sm">
      <Tree store={treeStore} renderNode={renderNode} className={s.root__tree} />
    </Flex>
  );
};

export default observer(TreeSelect);
